import React from 'react';

import { SingleDatePicker } from 'react-dates';

import Calendar from 'lib/Calendar';
import has from 'lodash/has';

class DatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: props.focused || false,
      date: props.date || null,
    };

    this.onDateChange = this.onDateChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
    this.isOutsideRange = this.isOutsideRange.bind(this);
  }

  onDateChange(date) {
    this.setState({ date });

    if (this.props.onDateChange) {
      this.props.onDateChange(date);
    }
  }

  onFocusChange({ focused }) {
    this.setState({ focused });

    if (this.props.onFocusChange) {
      this.props.onFocusChange(focused);
    }
  }

  isOutsideRange(day) {
    if (this.props.isOutsideRange) {
      return this.props.isOutsideRange(day);
    }
    return false;
  }

  render() {
    const { focused, date } = this.state;

    let dateFormat = Calendar.getDateMomentFormat();

    if(has(this.props, 'dateFormat')) {
      dateFormat = this.props.dateFormat;
    }

    return (
      <SingleDatePicker
        {...this.props}
        id="date_input"
        date={date}
        focused={focused}
        onDateChange={this.onDateChange}
        onFocusChange={this.onFocusChange}
        numberOfMonths={1}
        isOutsideRange={this.isOutsideRange}
        withFullScreenPortal
        enabledOutsideDays
        displayFormat={dateFormat}
      />
    );
  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./src/app/components/calendar/DatePicker.js